import Component from '../../../shared/component';
import RemoteReloadingElement from '../../../shared/components/remote-reloading-element';
import ConversationUploadButton from './conversation-upload-button';

const REFRESH_INTERVAL = 20000;
const SELECTED_FILE_DISABLE_CLASS = 'messageForm-selectedFile--disabled';
const PROGRESS_BAR_VISIBLE_CLASS = 'messageForm-progressBar--visible';

export default class Conversation extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);
    this.isSubmitting = false;

    this.$conversationList = opts.conversationList;

    this.$formElement = this.$element.find('.messageForm');
    this.$messagesElement = this.$element.find('.conversation-messages');
    this.$moreLinkElement = this.$element.find('.conversation-messages-more');
    this.$submitButton = this.$element.find('.messageForm-button');
    this.$selectedFileElement = this.$element.find('.messageForm-selectedFile');
    this.$textFieldElement = this.$element.find('.messageForm-field');
    this.$progressBarElement = this.$element.find('.messageForm-progressBar');

    this.uploadButton = new ConversationUploadButton('.messageForm-actions');

    this.bindEvents();
    this.bindTimeout();

    this.toggleMoreLinkElement();
    this.scrollMessagesList();
  }

  bindEvents() {
    this.handleMoreClick = this.handleMoreClick.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.$formElement.on('submit.Conversation', this.handleFormSubmit);
    this.$moreLinkElement.on('click.Conversation', this.handleMoreClick);

    window.$window.on('resize.Conversation', this.handleWindowResize);
    window.$document.on(
      'turbolinks:before-visit.Conversation',
      this.handlePageChange
    );

    this.uploadButton.bindEvents();
  }

  unbindEvents() {
    this.$formElement.off('submit.Conversation', this.handleFormSubmit);
    this.$moreLinkElement.off('click.Conversation', this.handleMoreClick);

    window.$window.off('resize.Conversation', this.handleWindowResize);
    window.$document.off(
      'turbolinks:before-visit.Conversation',
      this.handlePageChange
    );

    if (this.remoteReloadingElements) {
      this.remoteReloadingElements.forEach((element) => element.unbindEvents());
    }

    this.uploadButton.unbindEvents();

    this.unbindTimeout();
  }

  bindTimeout() {
    this.timeout = setTimeout(() => {
      if (!this.timeout) return;

      this.fetchData();
    }, REFRESH_INTERVAL);
  }

  unbindTimeout() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  toggleMoreLinkElement() {
    const maxMessagesShown = 20;

    if (
      this.$messagesElement.children('.message').length === maxMessagesShown
    ) {
      this.$moreLinkElement.show();
    }
  }

  handleFormSubmit() {
    this.disableForm();
  }

  handleWindowResize() {
    this.scrollMessagesList();
  }

  handlePageChange() {
    if (this.isSubmitting)
      // eslint-disable-next-line no-alert
      return window.confirm(this.$formElement.data('cancel-confirm-message'));
  }

  handleMoreClick() {
    this.$moreLinkElement.trigger('blur');
    this.fetchOldMessages();
  }

  handleNewMessagesSuccess(data) {
    this.appendMessages(data);
    this.bindTimeout();
  }

  handleOldMessagesSuccess(data) {
    if (String(data).trim() !== '') {
      const originalHeight = this.$messagesElement[0].scrollHeight;
      this.prependMessages(data);
      this.$messagesElement[0].scrollTop =
        this.$messagesElement[0].scrollHeight - originalHeight;
    } else {
      this.$moreLinkElement.remove();
    }
  }

  disableForm() {
    this.isSubmitting = true;

    this.$selectedFileElement.addClass(SELECTED_FILE_DISABLE_CLASS);
    this.$submitButton.prop('disabled', true);
    this.$textFieldElement.prop('readonly', true);
    this.$progressBarElement.addClass(PROGRESS_BAR_VISIBLE_CLASS);
  }

  appendMessages(messages) {
    if (String(messages).trim() !== '') {
      this.$messagesElement.append(messages);
      this.bindNewEvents();
      this.scrollMessagesList();
    }
  }

  bindNewEvents() {
    this.remoteReloadingElements = RemoteReloadingElement.initialize(
      this.$messagesElement.find('.remoteReloadingElement')
    );
  }

  prependMessages(messages) {
    this.$moreLinkElement.after(messages);
    this.bindNewEvents();
  }

  scrollMessagesList() {
    this.$messagesElement[0].scrollTop = this.$messagesElement[0].scrollHeight;
  }

  fetchOldMessages() {
    const $firstMessageElement = this.$messagesElement
      .find('.message, .interactionMessage')
      .first();

    const until = $firstMessageElement.data('created-at');

    $.get(this.$formElement.attr('action'), {until}).done((data) =>
      this.handleOldMessagesSuccess(data)
    );
  }

  fetchData() {
    this.fetchNewMessages();
    this.$conversationList.fetchData();
  }

  fetchNewMessages() {
    const $lastMessageElement = this.$messagesElement
      .find('.message, .interactionMessage')
      .last();

    const since = $lastMessageElement.data('created-at');

    $.get(this.$formElement.attr('action'), {since}).done((data) =>
      this.handleNewMessagesSuccess(data)
    );
  }
}
